// Thin wrapper around the Mogul tracker's global `mogul()` function.
//
// The tracker (script.plus.js) loads with `defer`, and the layout installs a
// small queue stub before it, so calls fired by React before the tracker
// finishes loading are queued and drained rather than lost. We still guard
// defensively here: the snippet may be absent (ad-blocked, disabled in an
// env), and analytics must NEVER throw into a real user flow.
//
// Usage:
//   import { track } from '@/utils/mogul'
//   track('Checkout: Subscribe Clicked', { plan: 'gold', interval: 'yearly' })
export const track = (name, props) => {
  try {
    if (typeof window.mogul === 'function') {
      window.mogul(name, props ? { props } : undefined)
    }
  } catch (_) { /* never let analytics break the app */ }
}

export default track
